<template>
    <static-layout>
        <template v-slot:header>
            <Header title="Metropolitan Museum of Art"/>
        </template>
        <template v-slot:info-area>
            <TopInfo/>
        </template>
        <template>
            <div>
                <div class="adjust">
                    <CarouselOne :max=2>
                        <slide>
                            <div class="d-flex slide-type-2">
                                <div>
                                    <div></div>
                                </div>
                                <div>
                                    <h2>Per gli amanti dell'arte 2</h2>
                                    <p>Il Metropolitan Museum of Art, a cui spesso ci si riferisce con il nomignolo di "The Met", è uno dei più grandi ed importanti musei del mondo.
                                        La sua sede principale si trova sul lato sinistro del Central Park a New York, lungo quello che viene chiamato il Museum Mile.
                                        Nel 1986 è stato inserito nella lista dei National Historic Landmark. Il Met dispone anche di una sede secondaria, chiamata The Cloisters, che contiene la sezione dedicata all'arte medievale.
                                        La collezione permanente del Met contiene più di due milioni di opere d'arte, suddivise in diciannove sezioni. Sono permanentemente esposte opere risalenti all'antichità classica e all'antico Egitto, dipinti e sculture di quasi tutti i più grandi maestri Europei e una vasta collezione di arte statunitense e moderna.</p>
                                </div>
                            </div>
                        </slide>
                        <slide>
                            <div class="d-flex slide-type-2">
                                <div>
                                    <div></div>
                                </div>
                                <div>
                                    <h2>Per gli amanti dell'arte 2</h2>
                                    <p>Il Metropolitan Museum of Art, a cui spesso ci si riferisce con il nomignolo di "The Met", è uno dei più grandi ed importanti musei del mondo.
                                        La sua sede principale si trova sul lato sinistro del Central Park a New York, lungo quello che viene chiamato il Museum Mile.
                                        Nel 1986 è stato inserito nella lista dei National Historic Landmark. Il Met dispone anche di una sede secondaria, chiamata The Cloisters, che contiene la sezione dedicata all'arte medievale.
                                        La collezione permanente del Met contiene più di due milioni di opere d'arte, suddivise in diciannove sezioni. Sono permanentemente esposte opere risalenti all'antichità classica e all'antico Egitto, dipinti e sculture di quasi tutti i più grandi maestri Europei e una vasta collezione di arte statunitense e moderna.</p>
                                </div>
                            </div>
                        </slide>
                    </CarouselOne>
                </div>
                <div class="mb-3">
                    <GmapMap :center="{lat:40.7794, lng:-73.9632}" :zoom="15" map-type-id="terrain" class="map"/>
                </div>
                <div class="mb-3">
                    <ProssimiTour title="Potrebbe interessarti" subtitle="Soluzioni di viaggio pensate per te"/>
                </div>
            </div>
        </template>
        <template v-slot:footer>
        </template>
    </static-layout>
</template>

<script>
import StaticLayout from './layout/StaticLayout'
import Footer from './layout/common/Footer'
import Header from './layout/static/Header'
import CarouselOne from '../widgets/common/CarouselOne'
import TopInfo from '../widgets/pages/detail/TopInfo'
import ProssimiTour from '../widgets/pages/home/ProssimiTour'
export default {
  name: 'Detail',
  components: {ProssimiTour, TopInfo, CarouselOne, Header, Footer, StaticLayout}
}
</script>

<style scoped>
    .adjust {
        margin-left: 80px;
        margin-bottom: 50px;
    }
    .map {
        width: 100%;
        height: 430px
    }
</style>



// WEBPACK FOOTER //
// src/front/components/pages/Detail.vue